import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import { Stack } from '@mui/material'

export const CardContainer = styled(Stack)<CmsProps>`
  width: 17.5rem;
  height: 37rem;
  margin: 0;
`
